module.exports = __webpack_public_path__ + "img/2ezBanner3Mobile.be438027.jpg";